<template>
    <div class="scancode bg-color">
        <!-- <div style="background-color: #e93323;height:1rem"></div> -->
        <div class="headerCon">
            <div class="hdleft">
                <div class="tt">
                    <div class="name">条码数目</div>
                    <div>
                        <span class="num">{{total}}</span>个
                    </div>
                </div>
                <div class="tt">
                    <div class="name">今日新增</div>
                    <div>
                        <span class="num">{{total1}}</span>个
                    </div>
                </div>
            </div>
            <div class="iconfont icontuandui1"></div>
        </div>
        <div style="clear:both;"></div>
        <div class="search setbackground">
            <div class="search-box flex-box">
                <span class="search-window searchs">
                    <input placeholder="请输入瓶码" v-model="keywords" />
                </span>
                <span class="iconfont iconsoushuo searchs" @click="setkeyword()"></span>
            </div>
        </div>
        <div class="screen setbackground flex-box">
            <div class="screen-block screen-left" @click="setTime()">
                时间筛选
                <img src="@assets/images/sort2.png"/>
            </div>
            <Popup v-model="showTime" position="bottom">
                <DatetimePicker 
                    type="date"
                    :visible-item-count="7"
                    :min-date="minDate"
                    :max-date="maxDate"
                    v-model="currentDate"
                    value-key="date" 
                    @confirm="onConfirmTime"
                    @cancel="onCancelTime"/>
            </Popup>
            <div @click.stop="selectBrand()" class="screen-block screen-right" >
                品牌筛选
                <img src="@assets/images/sort2.png"/>
            </div>
            <Popup v-model="showBrand" position="bottom">
                <Picker show-toolbar  :columns="columnsBrand" value-key="name" @confirm="onConfirm" @cancel="onCancel"/>
            </Popup>
        </div>
        <div class="userlist" v-if="list.length">
            <div class="flex-box" v-for="(item,index) in list" :key="index" @click="goPage('/Tasting/user/scanuser?unique'+item.unique1)">
                <!-- <span class="head-img user-public">
                    <img :src="item.avatar" />
                </span> -->
                <div class="middle-box user-public">
                    <div class="username user-publics">
                        <span>条码：</span>{{item.unique1}}
                    </div>
                    <div class="scantime user-publics Ellipses1">
                        <span>所属门店：</span>{{item.name}}
                    </div>
                    <div class="scantime user-publics">
                        <span>入库时间：</span>{{item.date}}
                    </div>
                </div>
                <div class="behind-box user-public">
                    <div class="productname user-publics Ellipses1">
                        <span>所属商品：</span>{{item.pname}}
                    </div>
                    <div class="cityname user-publics Ellipses1">
                        <span>所属分销商：</span>{{item.cname}}
                    </div>
                </div>
                <div class="user-public" style="width: 18%;text-align: center;">
                    <div class="productname user-publics">
                        <span>{{item.cnum ? item.cnum : 0}}扫码数</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="Loading" v-if="loading">
            <Loading size="24px">加载中...</Loading>
        </div>
        <div class="Loading" v-if="finished">没有更多了~</div>
        <div v-if="noData">
            <img src="@assets/images/noData.png"/>
        </div>
        <!-- <Time :status4="zt" @gettime='getDate($event)' v-model="time"></Time> -->
        <!-- <CitySelect
        v-model="show3"
        :callback="result2"
        :items="district"
        provance=""
        city=""
        ></CitySelect> -->
    </div>
</template>
<script>
    import { getCodeList,getpinpai } from "@api/tasting";
    import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
    import District from "ydui-district/dist/gov_province_city_new.js";
    import { Icon, Toast, Tab, Tabs ,Popup ,Picker ,DatetimePicker  } from "vant";
    import Time from "../../components/Time";
    export default {
        name: "scancode",
        data: function() {
            return {
                loading:false,
                finished:false,
                //zt:0,
                noData:false,
                time:0,
                //provance:'',
                //city:'',
                show3: false,
                model2: "",
                district: District,
                list:[],
                page:1,
                limit:20,
                keywords:'',
                total:0,
                total1:0,

                columnsBrand:[],
                showBrand:false,
                brand_id:0,

                //时间
                showTime:false,
                starttime: '', //开始时间 数字   默认选中当天日期
                //endtime: '', //结束时间 数字
                minDate: new Date(1970, 0, 1),//可选的最小时间
                maxDate: new Date(2121,12,31),//可选最大时间
                currentDate: new Date(),//默认选择的时间
            };
        },
        components: {
            Icon, Toast, Tab, Tabs ,Time ,District ,CitySelect ,Popup ,Picker ,DatetimePicker
        },
        mounted: function() {
            this.Loadmore();
            var that=this;
            window.addEventListener("scroll", function(event) {
                var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                if(document.documentElement.scrollHeight == document.documentElement.clientHeight + scrollTop) {
                    that.Loadmore();
                }
            });
        },
        methods: {
            onCancel() {
                this.showBrand = false;
            },
            onConfirm(value, index) {
                this.showBrand = false;
                //console.log(index);
                if(this.columnsBrand[index]){
                    this.brand_id = this.columnsBrand[index].id;
                    this.chongzhi();
                    this.starttime = '';
                    this.endtime = '';
                    this.keywords = '';
                    this.Loadmore();
                }
            },
            selectBrand(){
                //this.zt = 0;
                this.showBrand = true;
                this.columnsBrand=[];
                this.getBrandList();
            },
            getBrandList(){
                getpinpai().then(res => {
                    let datalist = res.data.pinpai;
                    this.columnsBrand=datalist;
                })
                .catch(err => {
                    Toast.fail({
                        message: err.msg,
                        forbidClick: true,
                    });
                });
            },
           //跳转
           goPage:function(url){
               this.$router.push({ path: url });
           },
           //加载列表
           Loadmore(){
               if(this.loading)return;
               if(this.finished)return;
               this.getlist();
           },
           //选择时间开关
           setTime(){
               this.showTime = true;
           },
           //条件重置
           chongzhi(){
                this.list = [];
                this.loading = false;
                this.finished = false;
                this.page = 1;
                this.limit = 20;
           },
           onCancelTime() {
                this.showTime = false;
            },
            onConfirmTime(val) {
                let year = val.getFullYear()
                let month = val.getMonth() + 1
                let day = val.getDate()
                this.starttime = `${year}-${month}-${day}`
                this.starttime = new Date(this.starttime.replace(/-/g, '/')).getTime();//ios
                this.showTime = false;
                this.getDate();
            },
           //时间范围筛选
           getDate(e){
               this.chongzhi();
               this.brand_id=0;
               this.keywords = '';
               this.Loadmore();
           },
           //城市
           setCity(){
               //this.zt=0;
               this.show3 = true;
           },
           //城市筛选
        //    result2(ret) {
        //         this.city = ret.itemName2;
        //         this.chongzhi();
        //         this.starttime = '';
        //         this.endtime = '';
        //         this.keywords = '';
        //         this.Loadmore();
        //     },
           //搜索
            setkeyword() {
                //this.zt=0;
                //this.city = '';
                this.chongzhi();
                this.starttime = '';
                this.endtime = '';
                //this.keyword = '';
                this.Loadmore();
            },
           //请求列表数据
           getlist(){
               this.noData = false;
               getCodeList({
                    page:this.page,
                    limit:this.limit,
                    keyword:this.keywords,
                    start_time:this.starttime,
                    end_time:this.endtime,
                    pinpai:this.brand_id
               }).then(res=>{
                   var listdata = res.data.list;
                   this.total = res.data.total;
                   this.total1 = res.data.total1;
                    listdata.forEach((item)=>{
                        this.list.push(item);
                    })
                    this.loading = false;
                    this.page++;
                    if(listdata.length<20){
                        if(this.list.length<=0){
                            this.noData = true;
                        }else{
                            this.finished = true;
                        }
                    }
               }).catch(err => {
                    this.loading = false;
                    Toast.fail({
                        message: err.msg,
                        forbidClick: true,
                    });
               });
           }
        }
    }
</script>
<style lang="scss">
    .Loading{
        padding-top: 0.1rem;
        color: #ccc;
        text-align: center;
    }
    .scancode{
        width: 100%;
        height: 2rem;
    }
    .scancode .bg-color {
        background-color: #e93323!important;
    }
    .scancode .headerCon{
        width: 100%;
        height: 100%;
        padding: 0.2rem 0.5rem 0 0.5rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        color: #fff;
        background-image: url(data:image/png;base64,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);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
    }
    .scancode .hdleft{
        font-weight: 600;
        .tt {
            float: left;
            margin-left: 0.2rem;
            padding-top: 0.3rem;
            .num{
                font-size: 0.6rem;
            }
        }
    }
    .scancode .iconfont{
        font-size: 1.6rem;
        float: right;
    }   
    .scancode .setbackground{
        width: 100%;
        background-color: #fff;
    }
    .scancode .flex-box{
        padding:0.2rem ;
        display: flex;
        align-items: center;
        .searchs{

        }
        .search-window{
            width: 90%;
            height: 0.6rem;
            //border: 2px solid #000;
            background-color: #f5f5f5;
            border-radius: 0.6rem;
            margin-right:0.2rem ;
            color: #000;
            input{
                text-align: center;
                width: 100%;height: 100%;
            }
            input::-ms-input-placeholder{text-align: center;}
            input::-webkit-input-placeholder{text-align: center;}
            
        }
        .iconfont{
            font-size: 0.5rem;
            color: #000;
            float: unset;
        }
    }
    .scancode .screen{
        flex-wrap: wrap;
        margin-top: 0.15rem;
        border-bottom: 1px solid #eee;
        color: #000;
        font-size: 0.3rem;
        text-align: center;
        img{
            width: 0.3rem;
            vertical-align: -0.05rem;
        }
        .screen-block{
            flex-direction:row;justify-content:space-evenly;width: 50%;
        }
    }
    .scancode .userlist{
         flex-wrap: wrap;
         background-color: #fff;
        .user-public{
            flex-direction:row;justify-content:space-evenly;padding-right: 0.1rem;
            color: #000;
        }
        .head-img{
            img{
                border-radius: 50%;
                width: 1rem;
                height: 1rem;
                border: 2px solid #fff;
                box-shadow: 0 0 0.1rem #aaa;
            }
        }
        .user-publics{
            font-size: 0.2rem;
        }
        .middle-box{
            width: 45%;
            .username{
                padding-bottom: 4%;
            }
            .scantime{
                color: #ccc;
                
            }
        }
        .behind-box{
            width: 36%;
            .productname{
                padding-top: 4%;
            }
        }
    }
</style>